import { Card } from "../../ui";
import { formatPhone } from "../../../lib/masks";
import { ROLES } from "./shared";

export function UserCreateForm({ busy, form, openCreate, setForm, setOpenCreate, submitCreate }) {
  return (
    <>
      {openCreate && (
        <Card className="p-5 mb-6">
          <form
            data-testid="new-internal-user-form"
            onSubmit={submitCreate}
            className="grid md:grid-cols-2 gap-3"
          >
            <div>
              <label className="text-[11px] uppercase tracking-[0.22em] text-slate-500">
                Nome completo *
              </label>
              <input
                data-testid="iu-name"
                required
                minLength={2}
                value={form.name}
                onChange={(e) => setForm({ ...form, name: e.target.value })}
                className="mt-1 w-full border border-slate-300 px-3 py-2.5 rounded-sm"
              />
            </div>
            <div>
              <label className="text-[11px] uppercase tracking-[0.22em] text-slate-500">
                Função *
              </label>
              <select
                data-testid="iu-role"
                value={form.role}
                onChange={(e) => setForm({ ...form, role: e.target.value })}
                className="mt-1 w-full border border-slate-300 px-3 py-2.5 rounded-sm bg-white"
              >
                {ROLES.map((r) => (
                  <option key={r.value} value={r.value}>
                    {r.label}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label className="text-[11px] uppercase tracking-[0.22em] text-slate-500">
                E-mail *
              </label>
              <input
                data-testid="iu-email"
                type="email"
                required
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                className="mt-1 w-full border border-slate-300 px-3 py-2.5 rounded-sm"
              />
            </div>
            <div>
              <label className="text-[11px] uppercase tracking-[0.22em] text-slate-500">
                Telefone
              </label>
              <input
                data-testid="iu-phone"
                value={form.phone}
                onChange={(e) =>
                  setForm({ ...form, phone: formatPhone(e.target.value) })
                }
                maxLength={15}
                placeholder="(11) 99999-9999"
                className="mt-1 w-full border border-slate-300 px-3 py-2.5 rounded-sm"
              />
            </div>
            <div className="md:col-span-2">
              <label className="text-[11px] uppercase tracking-[0.22em] text-slate-500">
                Senha inicial * (mín. 8 caracteres)
              </label>
              <input
                data-testid="iu-password"
                type="text"
                required
                minLength={8}
                value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })}
                className="mt-1 w-full border border-slate-300 px-3 py-2.5 rounded-sm font-mono"
              />
              <p className="mt-1 text-xs text-slate-500">
                Será enviada por e-mail ao usuário. Ele poderá alterá-la no
                primeiro acesso.
              </p>
            </div>
            <div className="md:col-span-2 flex gap-2">
              <button
                disabled={busy}
                data-testid="iu-submit"
                className="px-5 py-2.5 bg-[#0A0F14] text-white text-[11px] uppercase tracking-[0.22em] hover:bg-[#002776] disabled:opacity-60"
              >
                {busy ? "Salvando..." : "Criar usuário"}
              </button>
              <button
                type="button"
                onClick={() => setOpenCreate(false)}
                className="px-5 py-2.5 border border-slate-300 text-[11px] uppercase tracking-[0.22em] hover:border-[#002776]"
              >
                Cancelar
              </button>
            </div>
          </form>
        </Card>
      )}

    </>
  );
}
